module.exports = __webpack_public_path__ + "static/media/schody43 - schody drewniane nakladane.e270d5e3.jpg";